var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.loadSounds}},[_vm._v("Load Sounds")]),_c('p',[_vm._v(_vm._s(_vm.display))]),_c('p',[_vm._v(_vm._s(_vm.log))])])}
var staticRenderFns = []

export { render, staticRenderFns }